import { FC } from 'react';
import { Button, Col, Form, Input, InputNumber, message, Row, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectRoleField from '../fields/select-role-field';
import Password from 'antd/lib/input/Password';
import SelectUsersField from '../fields/select-user-field';

interface Prop { id: string | null }

const DiscountForm: FC<Prop> = ({ id }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	React.useEffect(() => {
		if (id === null) return
		setLoading(true)
		restful.get('discounts/' + id + "/form")
			.then((res) => {
				form.setFieldsValue(res.data.result.form)
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));;
	}, [])

	function onFinish(data: any) {
		setLoading(true)
		restful.request({
			data,
			method: id ? "PUT" : "POST",
			url: id ? `/discounts/${id}` : "/discounts"
		}).then((res) => {
			if (id === null) form.resetFields()
			message.success("انجام شد")
		})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (
		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical" autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24} md={12}  >
						<Form.Item name="code" label="کد "
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="percent" label="درصد "
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="maximum" label="حداکثر "
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>


					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default DiscountForm;
